import Vue from 'vue'
import App from './App'
import router from './router'
import mixin from './helpers/funcoes';
import io from 'socket.io-client';
import Vuex from 'vuex'
import {store} from './store/store'
import Cookies from 'js-cookie';
import VueMask from 'vue-the-mask';

require ('./assets/css/bootstrap.min.css');
require ('./assets/css/style.css');
// require ('./assets/js/popper.min.js');
// require ('./assets/js/bootstrap.min.js');

// const socket = io(process.env.BASE_SOCKET).on('countSocket', (data) => {
//   console.log("assistindo: " + data)
// });


const socket = io(process.env.BASE_SOCKET);

try {
    socket.on('countSocket', (data) => {
        console.log("assistindo: " + data);
        // Outro código relacionado ao evento 'countSocket' aqui
    });
} catch (error) {
    console.error("Ocorreu um erro:", error);
    // Outras ações de tratamento de erro, se necessário
}

store.commit('set_socket', socket);


Vue.config.productionTip = false

Vue.use(Vuex)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})





// WEBPACK FOOTER //
// ./src/main.js